/* tslint:disable */

declare var Object: any;
export interface OfferCodeInterface {
  "id": string;
  "code": string;
  "used": boolean;
  "usedby"?: string;
  "limitedTimeOfferId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class OfferCode implements OfferCodeInterface {
  "id": string;
  "code": string;
  "used": boolean;
  "usedby": string;
  "limitedTimeOfferId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: OfferCodeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `OfferCode`.
   */
  public static getModelName() {
    return "OfferCode";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of OfferCode for dynamic purposes.
  **/
  public static factory(data: OfferCodeInterface): OfferCode{
    return new OfferCode(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'OfferCode',
      plural: 'OfferCodes',
      path: 'OfferCodes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "used": {
          name: 'used',
          type: 'boolean',
          default: false
        },
        "usedby": {
          name: 'usedby',
          type: 'string'
        },
        "limitedTimeOfferId": {
          name: 'limitedTimeOfferId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/OfferCode.ts